<cm-table #tableElement id="reporting-preview">
  <cm-table-head>
    <cm-table-row>
      @for (column of table.columns; track column) {
        <cm-table-header data-not-resizable>
          {{ column.name }}
          @if (column.description) {
            <span [cm-tooltip]="column.description"
              class="cm-icon cm-icon-information-open"
              aria-hidden="true"
            ></span>
          }
        </cm-table-header>
      }
    </cm-table-row>
  </cm-table-head>
  <cm-table-body>
    @for (row of table.rows; track row) {
      <cm-table-row>
        @for (cell of row.cells; track cell) {
          <cm-table-data>{{ cell.value }}</cm-table-data>
        }
      </cm-table-row>
    }
  </cm-table-body>
</cm-table>
